import React, {useContext, useState} from 'react';
import {FaDownload} from 'react-icons/fa';
import {AppCtx} from '../../../AppCtx';
import {ADORANS_WORKSPACE_ID} from '../../../shared/services/workspaceAccess';
import {exportLegacySession} from '../../../shared/services/legacyMigrationExport';
import {SongBackupService} from '../../song/services/song-backup-service';

export default function LegacyMigrationNotice() {
  const {currentSessionId} = useContext(AppCtx);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState('');
  if (process.env.REACT_APP_HOSANNA_DIRECT !== '1' || !currentSessionId ||
    `songs-storage-${currentSessionId}` === ADORANS_WORKSPACE_ID) return null;
  const download = async localOnly => {
    setBusy(true); setError(''); setResult('');
    try {
      const archive = await exportLegacySession(currentSessionId, {localOnly});
      SongBackupService.downloadBlob(archive.blob, archive.fileName);
      setResult(`Przygotowano ZIP: ${archive.fileCount} plików.${localOnly ? ' Kopia lokalna może być niepełna.' : ''}`);
    } catch (failure) {setError(failure.message || 'Nie udało się przygotować kopii.');}
    finally {setBusy(false);}
  };
  return <section className="dashboard-tile legacy-migration" aria-label="Migracja prywatnej sesji">
    <div className="dashboard-tile-heading"><FaDownload/><h2>Przenieś swoją sesję do Hosanny</h2></div>
    <p>Ta prywatna sesja nie synchronizuje się w nowej Chwale. Pobierz dane ze starej sesji i przenieś śpiewniki do własnego pokoju w <a href="https://hosanna.panu.pl" target="_blank" rel="noreferrer">hosanna.panu.pl</a>.</p>
    <p>Rozpakuj pobrany ZIP, a następnie przeciągnij plik spiewniki.zip do drzewa plików w Hosannie. Pozostałym osobom przyznaj dostęp do tego samego pokoju. Ulubione, historia i dawne backupy pozostaną w archiwum; nie zostaną automatycznie zaimportowane.</p>
    <button type="button" className="dashboard-more" disabled={busy} onClick={() => download(false)}>{busy ? 'Przygotowywanie kopii…' : 'Pobierz ZIP starej sesji'}</button>
    {error && <><p role="alert">{error}</p><button type="button" className="dashboard-more" disabled={busy} onClick={() => download(true)}>Pobierz tylko lokalną kopię (może być niepełna)</button></>}
    {result && <p role="status">{result}</p>}
  </section>;
}
